import { useCallback, useEffect, useState } from 'react';
import { ShopClothesItem } from '~/components/ui/ShopClothesItem';
import { IClothesShopItem, rage, useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import {
	setActiveItemId,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';

const ListTabItem = ({
	item,
	index,
	handleSelect,
	variationIndex,
	onVariationChange,
	category,
}: {
	item: { id: string; items: IClothesShopItem[] };
	index: number;
	handleSelect: (index: number) => void;
	variationIndex: number;
	onVariationChange: (newIndex: number) => void;
	category: string;
}) => {
	const dispatch = useLayoutDispatch();
	const activeListIndex = useLayoutSelector(
		(state) => state.clothesShop.activeListIndex,
	);
	const tabIndex = useLayoutSelector((state) => state.clothesShop.tabIndex);

	const variationItem = item.items[variationIndex];
	const seenTrackerKey = `${tabIndex}.${variationItem.category}.${variationItem.id}`;
	const [isUnseen, setIsUnseen] = useState(
		rage.clothesShop.isUnseen(seenTrackerKey),
	);

	const handlePrevVariant = useCallback(() => {
		if (index !== activeListIndex || item.items.length === 1) return;

		const newIndex =
			variationIndex === 0 ? item.items.length - 1 : variationIndex - 1;
		onVariationChange(newIndex);
	}, [index, activeListIndex, variationIndex, item.items.length]);

	const handleNextVariant = useCallback(() => {
		if (index !== activeListIndex || item.items.length === 1) return;

		const newIndex =
			variationIndex === item.items.length - 1 ? 0 : variationIndex + 1;
		onVariationChange(newIndex);
	}, [index, activeListIndex, variationIndex, item.items.length]);

	useInputAction(InputAction.CommonMenuNavLeft, handlePrevVariant);

	useInputAction(InputAction.CommonMenuNavRight, handleNextVariant);

	useEffect(() => {
		if (index === activeListIndex) {
			dispatch(setActiveItemId(variationItem.id));
			rage.clothesShop
				.previewItem(variationItem.id)
				.catch((err) => rage.notifications.showException(err));
			rage.clothesShop.markSeen(seenTrackerKey);
			setIsUnseen(false);
		}
	}, [index, activeListIndex, variationIndex, seenTrackerKey]);

	return (
		<ShopClothesItem
			title={variationItem.name}
			price={variationItem.price}
			walletType={variationItem.wallet}
			id={`clothes-${item.id}`}
			itemId={variationItem.id}
			category={category}
			handleClick={() => handleSelect(index)}
			variantIndex={item.items.length > 1 ? variationIndex + 1 : undefined}
			maxVariantIndex={item.items.length}
			active={index === activeListIndex}
			oldPrice={variationItem.oldPrice}
			discount={variationItem.discount ?? 0}
			isNew={isUnseen}
			handlePrevVariant={handlePrevVariant}
			handleNextVariant={handleNextVariant}
		/>
	);
};

export { ListTabItem };
